/**
 * 表格单元格长文本截断：UUID / 批次号 / 编码不得撑破列宽覆盖邻列。
 * 完整值放 Tooltip，单元格内单行省略。
 */
import type { CSSProperties } from 'react';
import { Button, Tooltip, Typography } from 'antd';

const clipStyle: CSSProperties = {
  display: 'block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export interface EllipsisTextProps {
  value?: string | null;
  empty?: string;
}

/** 只读长文本（流水号、SKU ID 等）。 */
export function EllipsisText({ value, empty = '-' }: EllipsisTextProps) {
  if (!value) {
    return <Typography.Text type="secondary">{empty}</Typography.Text>;
  }
  return (
    <Tooltip title={value}>
      <span style={clipStyle}>{value}</span>
    </Tooltip>
  );
}

export interface EllipsisLinkProps {
  value: string;
  onClick: () => void;
  testId?: string;
}

/** 可点击长文本（批次号、订单号、学号等列表入口）。 */
export function EllipsisLink({ value, onClick, testId }: EllipsisLinkProps) {
  return (
    <Tooltip title={value}>
      <Button
        type="link"
        size="small"
        data-testid={testId}
        onClick={onClick}
        style={{
          ...clipStyle,
          padding: 0,
          height: 'auto',
          textAlign: 'left',
        }}
      >
        {value}
      </Button>
    </Tooltip>
  );
}
